import { Link } from "react-router-dom";
import { ASSETS, SUPPORT_EMAIL, COMPANY } from "@/lib/site";

const LEGAL = [
  { label: "Privacy / Cookie Policy", to: "/privacy" },
  { label: "Terms of Service", to: "/terms" },
  { label: "Accessibility", to: "/accessibility" },
];

export const Footer = () => {
  const year = new Date().getFullYear();

  return (
    <footer
      data-testid="site-footer"
      className="bg-brand-navy-deep text-slate-300"
    >
      <div className="mx-auto max-w-7xl px-6 md:px-10 lg:px-16 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-6">
            <img
              src={ASSETS.logoWhite}
              alt="Blue Shuck Consulting LTD"
              className="h-20 w-auto object-contain"
            />
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-slate-400">
              Boutique SaaS development for construction businesses.
            </p>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs font-semibold tracking-[0.18em] uppercase text-slate-500">
              Contact
            </p>
            <a
              data-testid="footer-email-link"
              href={`mailto:${SUPPORT_EMAIL}`}
              className="mt-4 inline-block text-sm text-slate-300 hover:text-white transition-colors"
            >
              {SUPPORT_EMAIL}
            </a>
            <address
              data-testid="footer-address"
              className="mt-4 not-italic text-sm leading-relaxed text-slate-400"
            >
              Blue Shuck Consulting LTD
              <br />
              Collingwood Buildings
              <br />
              38 Collingwood Street
              <br />
              Newcastle
              <br />
              NE1 1JF
            </address>
            <div className="mt-4">
              <Link
                data-testid="footer-blog-link"
                to="/blog"
                className="text-sm text-slate-300 hover:text-white transition-colors"
              >
                Insights / Blog
              </Link>
            </div>
          </div>

          <div className="md:col-span-3">
            <p className="text-xs font-semibold tracking-[0.18em] uppercase text-slate-500">
              Legal
            </p>
            <ul className="mt-4 space-y-3">
              {LEGAL.map((item) => (
                <li key={item.to}>
                  <Link
                    data-testid={`footer-link-${item.to.replace("/", "")}`}
                    to={item.to}
                    className="text-sm text-slate-300 hover:text-white transition-colors"
                  >
                    {item.label}
                  </Link>
                </li>
              ))}
              <li>
                <button
                  data-testid="footer-cookie-settings"
                  onClick={() => {
                    localStorage.removeItem("bs_cookie_consent");
                    window.location.reload();
                  }}
                  className="text-sm text-slate-300 hover:text-white transition-colors"
                >
                  Cookie settings
                </button>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-slate-400">
            &copy; {year} {COMPANY}. All rights reserved.
          </p>
          <div className="flex items-center gap-4">
            <p className="text-xs text-slate-500">
              North East of England &middot; Construction software specialists
            </p>
            <Link
              data-testid="footer-admin-link"
              to="/admin/login"
              className="text-xs text-slate-500 hover:text-white transition-colors"
            >
              Admin
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
};
